import React, { Component } from 'react';
import { Formik, Field, ErrorMessage, FieldProps } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Form, Grid, Header, Message, Segment } from 'semantic-ui-react';

import { appStateServerRequests } from '../redux/selectors';
import { getServerStateAction, resetPasswordRequestAction } from '../redux/actions';
import { ResetPasswordRequestValues } from '../interfaces';
import { ActionType, RootState, ServerRequestStatus } from '../redux/types';
import { TranslationComponent } from '../components/TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

const ResetPasswordSchema = (t: typeof i18n.t) =>
  Yup.object().shape({
    email: Yup.string().email(t('Invalid e-mail address')).required(t('Required field')),
  });

interface ResetPasswordRequestSceneProps extends Component {
  i18n: typeof i18n;
  t: typeof i18n.t;
  resetPasswordRequestAction: typeof resetPasswordRequestAction;
  serverRequest?: ServerRequestStatus;
}

class PResetPasswordRequestScene extends Component<ResetPasswordRequestSceneProps> {
  handleSubmit = (values: ResetPasswordRequestValues) => {
    this.props.resetPasswordRequestAction(values);
  };

  render() {
    const { serverRequest, t } = this.props;

    return (
      <Grid textAlign="center" style={{ height: '100vh' }} verticalAlign="middle">
        <Grid.Column style={{ maxWidth: 450 }}>
          <Header as="h2" textAlign="center">
            <TranslationComponent stringKey={'Reset password'} />
          </Header>
          <Formik
            initialValues={{
              email: '',
            }}
            validationSchema={ResetPasswordSchema(t)}
            onSubmit={this.handleSubmit}
          >
            {({ handleSubmit, isSubmitting }) => (
              <Form
                size="large"
                error
                loading={isSubmitting && serverRequest && serverRequest.pending}
                onSubmit={handleSubmit}
              >
                <Segment stacked>
                  <Field name="email">
                    {({ field }: FieldProps) => (
                      <Form.Input placeholder={t('E-mail address')} fluid icon="user" iconPosition="left" {...field} />
                    )}
                  </Field>
                  <ErrorMessage name="email">{(msg) => <Message error content={msg} />}</ErrorMessage>
                  <Button primary fluid size="large" type="submit">
                    <TranslationComponent stringKey={'Invia richiesta'} />
                  </Button>
                  {serverRequest && serverRequest.success && <Message content={t('Richiesta inviata')} />}
                  {serverRequest && serverRequest.error && <Message error content={t('Invio richiesta fallito')} />}
                </Segment>
              </Form>
            )}
          </Formik>
          <Message>
            <Link to="/signin">
              <TranslationComponent stringKey={'Torna al login'} />
            </Link>
          </Message>
        </Grid.Column>
      </Grid>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  serverRequest: appStateServerRequests(state, ActionType.RESET_PASSWORD_REQUEST),
});

export const ResetPasswordRequestScene = connect(mapStateToProps, {
  getServerStateAction,
  resetPasswordRequestAction: resetPasswordRequestAction,
})(withTranslation()(PResetPasswordRequestScene));
